// import PropTypes from "prop-types"
import React, { useEffect, useMemo, useRef, useState } from "react"
import { Col, Row, Input, Form, FormFeedback, Button, Spinner, Table } from "reactstrap";
import { Label, InputGroup, Card, CardBody, Tooltip } from "reactstrap";
import * as Yup from "yup";
import { useFormik, FieldArray, FormikProvider } from "formik";
import fn_helper, { slugify } from "helpers/fn_helper";
import PopupAttachment from "components/Input/attachment/PopupAttachment";
import MyEditor from "components/MyEditor";
import InputText from "components/Input/InputText";

const Page = ({
    validation,
    pageView
}) => {
    return (
        <>
            <Col className="col-12 mb-3">
                <label
                    htmlFor="businessName"
                    className="col-md-12 col-form-label"
                >
                    Business Name
                    <span className="t-require">*</span>
                </label>
                <div className="col-md-12">
                    <InputText
                        id="businessName"
                        className="form-control"
                        type="text"
                        placeholder=""
                        name="businessName"
                        onChange={e => {
                            validation.setFieldValue(
                                "businessName",
                                e.target.value
                            )
                        }}
                        onBlur={validation.handleBlur}
                        value={validation.values.businessName}
                        invalid={
                            validation.touched.businessName &&
                                validation.errors.businessName
                                ? true
                                : false
                        }
                        disabled={pageView === "view"}
                        maxLength={9999}
                    />
                    {validation.touched.businessName &&
                        validation.errors.businessName && (
                            <FormFeedback type="invalid">
                                {validation.errors.businessName}
                            </FormFeedback>
                        )}
                </div>
                <hr />
            </Col>
            <Col className="col-12 mb-3">
                <label
                    htmlFor="slug"
                    className="col-md-12 col-form-label"
                >
                    Slug
                    <span className="t-require">*</span>
                </label>
                <div className="col-md-12">
                    <InputText
                        id="slug"
                        className="form-control"
                        type="text"
                        placeholder=""
                        name="slug"
                        onChange={e => {
                            validation.setFieldValue(
                                "slug",
                                slugify(e.target.value)
                            )
                        }}
                        onBlur={validation.handleBlur}
                        value={validation.values.slug}
                        invalid={
                            validation.touched.slug &&
                                validation.errors.slug
                                ? true
                                : false
                        }
                        disabled={pageView === "view"}
                        maxLength={9999}
                    />
                    {validation.touched.slug &&
                        validation.errors.slug && (
                            <FormFeedback type="invalid">
                                {validation.errors.slug}
                            </FormFeedback>
                        )}
                </div>
                <hr />
            </Col>
            
            <Col className="col-6 mb-3">
                <div className="col-md-12">
                    <PopupAttachment
                        typeDetail="single"
                        typeUpload="ImageMap"
                        upload="Image"
                        prefixName="page-thumbnail"
                        label="Thumbnail image"
                        required={true}
                        description="description"
                        widthSize={888}
                        heightSize={479}
                        value={validation.values.thumbnail}
                        onChange={(value = {}, index) => {
                            console.log("🚀 onChange ~ value:", value)
                            console.log("🚀 onChange ~ index:", index)
                            validation.setFieldValue('thumbnail', value)
                        }}
                        onRemove={(index) => {
                            console.log("🚀 onChange ~ index:", index)
                            validation.setFieldValue('thumbnail', {})
                        }}
                    />
                    {validation.touched.thumbnail && validation.errors.thumbnail && (
                        <div type="invalid" className="invalid-feedback d-block">
                            {validation.errors.thumbnail}
                        </div>
                    )}
                </div>
                <hr />
            </Col>
            
            <Col className="col-6 mb-3">
                <div className="col-md-12">
                    <PopupAttachment
                        typeDetail="single"
                        typeUpload="ImageMap"
                        upload="Image"
                        prefixName="page-imageDescription"
                        label="Image Desctiption"
                        required={true}
                        description="description"
                        widthSize={675}
                        heightSize={900}
                        value={validation.values.imageDescription}
                        onChange={(value = {}, index) => {
                            console.log("🚀 onChange ~ value:", value)
                            console.log("🚀 onChange ~ index:", index)
                            validation.setFieldValue('imageDescription', value)
                        }}
                        onRemove={(index) => {
                            console.log("🚀 onChange ~ index:", index)
                            validation.setFieldValue('imageDescription', {})
                        }}
                    />
                    {validation.touched.imageDescription && validation.errors.imageDescription && (
                        <div type="invalid" className="invalid-feedback d-block">
                            {validation.errors.imageDescription}
                        </div>
                    )}
                </div>
                <hr />
            </Col>
            <Col className="col-12 mb-3">
                <label
                    htmlFor="descriptionHeader"
                    className="col-md-12 col-form-label"
                >
                    Bussiness header description
                    <span className="t-require">*</span>
                </label>
                <div className="col-md-12">
                    <MyEditor
                        id="descriptionHeader"
                        placeholder=""
                        name="descriptionHeader"
                        onChange={(e, editor) => {
                            const data = editor.getData()
                            validation.setFieldValue(
                                "descriptionHeader",
                                data
                            )
                            console.log({ e, editor, data })
                        }}
                        onBlur={validation.handleBlur}
                        value={validation.values.descriptionHeader}
                        invalid={
                            validation.touched.descriptionHeader &&
                                validation.errors.descriptionHeader
                                ? true
                                : false
                        }
                        disabled={pageView === "view"}
                    />
                    {validation.touched.descriptionHeader &&
                        validation.errors.descriptionHeader && (
                            <FormFeedback type="invalid">
                                {validation.errors.descriptionHeader}
                            </FormFeedback>
                        )}
                </div>
                <hr />
            </Col>
            <Col className="col-12 mb-3">
                <label
                    htmlFor="contentDetail"
                    className="col-md-12 col-form-label"
                >
                    Bussiness description
                    <span className="t-require">*</span>
                </label>
                <div className="col-md-12">
                    <MyEditor
                        id="contentDetail"
                        placeholder=""
                        name="contentDetail"
                        onChange={(e, editor) => {
                            const data = editor.getData()
                            validation.setFieldValue(
                                "contentDetail",
                                data
                            )
                            console.log({ e, editor, data })
                        }}
                        onBlur={validation.handleBlur}
                        value={validation.values.contentDetail}
                        invalid={
                            validation.touched.contentDetail &&
                                validation.errors.contentDetail
                                ? true
                                : false
                        }
                        disabled={pageView === "view"}
                    />
                    {validation.touched.contentDetail &&
                        validation.errors.contentDetail && (
                            <FormFeedback type="invalid">
                                {validation.errors.contentDetail}
                            </FormFeedback>
                        )}
                </div>
                <hr />
            </Col>
            <Col className="col-6 mb-3">
                <div className="col-md-12">
                    <PopupAttachment
                        typeDetail="single"
                        typeUpload="ImageMap"
                        upload="Image"
                        prefixName="page-banner-desktop"
                        label="Banner Desktop"
                        required={true}
                        description="description"
                        widthSize={2160}
                        heightSize={990}
                        value={validation.values.bannerDesktop}
                        onChange={(value = {}, index) => {
                            console.log("🚀 onChange ~ value:", value)
                            console.log("🚀 onChange ~ index:", index)
                            validation.setFieldValue('bannerDesktop', value)
                        }}
                        onRemove={(index) => {
                            console.log("🚀 onChange ~ index:", index)
                            validation.setFieldValue('bannerDesktop', {})
                        }}
                    />
                    {validation.touched.bannerDesktop && validation.errors.bannerDesktop && (
                        <div type="invalid" className="invalid-feedback d-block">
                            {validation.errors.bannerDesktop}
                        </div>
                    )}
                </div>
                <hr />
            </Col>
            <Col className="col-6 mb-3">
                <div className="col-md-12">
                    <PopupAttachment
                        typeDetail="single"
                        typeUpload="ImageMap"
                        upload="Image"
                        prefixName="page-banner-mobile"
                        label="Banner Mobile"
                        required={true}
                        description="description"
                        widthSize={540}
                        heightSize={780}
                        value={validation.values.bannerMobile}
                        onChange={(value = {}, index) => {
                            console.log("🚀 onChange ~ value:", value)
                            console.log("🚀 onChange ~ index:", index)
                            validation.setFieldValue('bannerMobile', value)
                        }}
                        onRemove={(index) => {
                            console.log("🚀 onChange ~ index:", index)
                            validation.setFieldValue('bannerMobile', {})
                        }}
                    />
                    {validation.touched.bannerMobile && validation.errors.bannerMobile && (
                        <div type="invalid" className="invalid-feedback d-block">
                            {validation.errors.bannerMobile}
                        </div>
                    )}
                </div>
                <hr />
            </Col>
            <Col className="col-12">
                <Card>
                    <h5 className="card-header bg-transparent border-bottom text-uppercase">
                        <i className="bx bx-trending-up"></i> SEO Box
                    </h5>
                    <CardBody>
                        <Row className="">
                            <Col className="col-12 mb-3">
                                <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                >
                                    Meta Title
                                    <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                    <InputText
                                        id="contentSeoTitle"
                                        className="form-control"
                                        type="text"
                                        placeholder="Page Title"
                                        name="contentSeoTitle"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.contentSeoTitle}
                                        invalid={
                                            validation.touched.contentSeoTitle &&
                                                validation.errors.contentSeoTitle
                                                ? true
                                                : false
                                        }
                                        disabled={pageView === "view"}
                                        maxLength={9999}
                                    />
                                    {validation.touched.contentSeoTitle &&
                                        validation.errors.contentSeoTitle && (
                                            <FormFeedback type="invalid">
                                                {validation.errors.contentSeoTitle}
                                            </FormFeedback>
                                        )}
                                </div>
                            </Col>
                            <Col className="col-12 mb-3">
                                <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                >
                                    Meta Description
                                    {/* <span className="t-require">*</span> */}
                                </label>
                                <div className="col-md-12">
                                    <InputText
                                        id="contentSeoDescription"
                                        className="form-control"
                                        type="text"
                                        placeholder="SEO Description"
                                        name="contentSeoDescription"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={
                                            validation.values.contentSeoDescription
                                        }
                                        invalid={
                                            validation.touched.contentSeoDescription &&
                                                validation.errors.contentSeoDescription
                                                ? true
                                                : false
                                        }
                                        disabled={pageView === "view"}
                                        maxLength={9999}
                                    />
                                    {validation.touched.contentSeoDescription &&
                                        validation.errors.contentSeoDescription && (
                                            <FormFeedback type="invalid">
                                                {validation.errors.contentSeoDescription}
                                            </FormFeedback>
                                        )}
                                </div>
                            </Col>
                            <Col className="col-12 mb-3">
                                <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                >
                                    Meta Keywords
                                    {/* <span className="t-require">*</span> */}
                                </label>
                                <div className="col-md-12">
                                    <InputText
                                        id="contentSeoKeyword"
                                        className="form-control"
                                        type="text"
                                        placeholder="SEO Keywords"
                                        name="contentSeoKeyword"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.contentSeoKeyword}
                                        invalid={
                                            validation.touched.contentSeoKeyword &&
                                                validation.errors.contentSeoKeyword
                                                ? true
                                                : false
                                        }
                                        disabled={pageView === "view"}
                                        maxLength={9999}
                                    />
                                    {validation.touched.contentSeoKeyword &&
                                        validation.errors.contentSeoKeyword && (
                                            <FormFeedback type="invalid">
                                                {validation.errors.contentSeoKeyword}
                                            </FormFeedback>
                                        )}
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </>
        )
}

export default Page